export enum ClientRoutes {
  Activities = "/activities",
  ActivitiesDrafts = "/activities?view=drafts",
  ActivitiesPublished = `${Activities}/published`,
  TagManager = "/tagmanager",
  Chapters = "/chapters",
  CreateChapter = "/chapters/create",
  ActivityPreview = "/activities/preview",
  ActivityCreate = "/activities/create",
  Media = "/media",
  MediaChapterPage = `${Media}?view=chapterimages`,
  MediaActivityPage = `${Media}?view=activityimages`,
  MediaChapterCreate = `${Media}/chapter/create`,
  MediaChapterEdit = `${Media}/chapter`,
  MediaActivityCreate = `${Media}/activity/create`,
  MediaActivityEdit = `${Media}/activity`,
  MediaActivityPublished = `${Media}/published`,
  MediaActivityDraft = `${Media}/drafts`,
  SystemAdmin = "/systemadmin",
  SystemInfoBanner = "/system-info-banner",
  SystemAdminCache = "/systemadmin/cache",
  SystemAdminSearchSettings = "/systemadmin/search-settings",
  SystemAdminDocumentManagement = "/systemadmin/document-management",
  SystemAdminLinkManagement = "/systemadmin/link-management",
  DocumentHealthCheck = "/systemadmin/document-health-check",
  ReindexJobMonitoring = "/systemadmin/reindex-status",
  SystemAdminUtilityLinks = "/systemadmin/utility-links",
  PublishedDocumentMetadataMigration = "/systemadmin/published-document-metadata-migration",
  PublishedMediaMetadataMigration = "/systemadmin/published-media-metadata-migration",
  ImageFileMigration = "/systemadmin/image-file-migration",
  ImageMetadataUpdater = "/systemadmin/image-metadata-updater",
  EntraGroupMemberships = "/permissions",
  Reports = "/reports",
  Tool = "/tools",
  ToolsDrafts = `${Tool}/drafts`,
  ToolsPublished = `${Tool}/published`,
  ToolsPublishedOld = `${Tool}/published/history`,
  ToolPreview = `${Tool}/preview`,
  ToolCreate = `${Tool}/create`,
  Documents = `${Tool}/documents`,
  Links = `${Tool}/links`,
  Roles = `/roles`,
}
